import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { BRAND } from "../lib/site";

// Premium cinematic loader — black bg, official logo, red progress line.
export default function Loader({ onDone }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setShow(false);
      setTimeout(() => onDone && onDone(), 700);
    }, 1800);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-pp-black noise"
          data-testid="loading-screen"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full" style={{ background: "radial-gradient(circle, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0.06) 40%, transparent 70%)" }} />
          <motion.div
            className="relative z-10 bg-white px-8 py-6"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <img src={BRAND.logo} alt="PHOTO PIXEL®" className="h-11 w-auto md:h-14" data-testid="loading-logo" />
          </motion.div>

          <p className="overline relative z-10 mt-7 text-white/60">{BRAND.slogan}</p>

          <div className="relative z-10 mt-6 h-[2px] w-60 overflow-hidden bg-white/15">
            <motion.div
              className="h-full bg-pp-red"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 1.6, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
